import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-issue-seller-challan-bill',
  standalone: true,
  imports: [CommonModule, MatDialogModule, HttpClientModule],
  templateUrl: './issue-seller-challan-bill.component.html',
  styleUrls: ['./issue-seller-challan-bill.component.scss']
})
export class IssueSellerChallanBillComponent {
  [x: string]: any;
  currentDate: string;
  showData: any;

 constructor(
     private dialogRef: MatDialogRef<IssueSellerChallanBillComponent>,
     @Inject(MAT_DIALOG_DATA) public data: any,
     private toaster: ToastrService,
     private service: DigisubservicesService
   ) {
    this.currentDate = new Date().toLocaleDateString('hi-IN');
    this.showData = data;
  }

  saveChallan() {
    const challanPayload = {
      challan_date: this.showData.cdate,
      challan_no: this.showData.challanno,
      issue_granth: this.showData.issuegrath,
      issue_date: this.showData.issue_date,
      delivery_mode: this.showData.delivery_mode,
      distribution_representative: this.showData.distribution_representative,
      distribution_mode: this.showData.distributionm,
      sub_distribution_mode: this.showData.subdistributionm,
      copies: this.showData.copies,
      total_amount: this.showData.totalamount,
      status: 'A'
      
    };

   this.service.insertchallanSaleInvoice(challanPayload).subscribe({
  next: (res) => {
    alert('चलन यशस्वीरित्या जतन झाले');
    this.dialogRef.close(true);
  },
  error: (err) => {
    console.error('Challan save failed:', err);
    alert('चलन सेव्ह करण्यात अडचण आली');
  }
});

  }

  generateChallanNo(): string {
    // Optional: You can replace this logic with server-generated or custom format
    const now = new Date();
    return 'CHLN-' + now.getFullYear() + (now.getMonth() + 1).toString().padStart(2, '0') + now.getDate();
  }
}
